import SectionWrapper from '@/components/feature/SectionWrapper';

const features = [
  {
    icon: 'ri-boxing-line',
    title: 'Elite Coaching',
    description: 'Train under an international boxer with proven competition experience and professional methodology.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Professional Environment',
    description: 'State-of-the-art training facility with premium equipment and a focused, no-distraction atmosphere.',
  },
  {
    icon: 'ri-user-line',
    title: 'All Levels Welcome',
    description: 'From complete beginners to competitive fighters — every program is adapted to your level.',
  },
  {
    icon: 'ri-medal-line',
    title: 'Proven Results',
    description: 'Over 500 students trained, multiple championships won, and countless transformations achieved.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-boxing-darker py-16 md:py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <SectionWrapper className="text-center mb-12 md:mb-16">
          <span className="section-label">/ Why Train With Us</span>
          <h2 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
            Why Choose <span className="text-highlight">Moin Khan</span>
          </h2>
          <div className="w-16 h-[2px] bg-boxing-red mx-auto mt-6" />
        </SectionWrapper>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <SectionWrapper key={feature.title} delay={index * 120}>
              <div className="card-glow bg-boxing-black/60 backdrop-blur-sm rounded-xl p-6 md:p-7 h-full border border-white/[0.06]">
                <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-boxing-red/10 rounded-lg mb-4">
                  <i className={`${feature.icon} text-boxing-red text-xl md:text-2xl`} />
                </span>
                <h3 className="font-oswald uppercase text-base md:text-lg tracking-wide text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-boxing-textgray text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </SectionWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}